import WebSpinner from "@/components/common/loaders/spinner/Spinner";
import { SPINNER_SIZES } from "@/components/common/loaders/spinner/spinnerConstants";

const SuspenseFallback = () => {
  return (
    <div className="flex full full-height center align-center">
      <WebSpinner size={SPINNER_SIZES.MEDIUM} />
    </div>
  );
};

export default SuspenseFallback;
